
// llama al repositorio 

import { crearProductoConPrecio } from '../infraestructure/supabase/productosPrecio.repository.js'

export async function crearProductoPrecioUseCase(data) {

  // Insertar BOM
  const productoCreado = await crearProductoConPrecio({
    producto_linea: data.producto_linea,
    producto_insumo: data.producto_insumo,
    cantidad: data.cantidad,
    unidad: data.unidad || 'UND',
    created_by: data.usuario || 'interface',
  })

  if (!productoCreado) {
    throw new Error('[crearProductoPrecioUseCase]No se pudo crear el producto con precio')
  }

  console.log('[crearProductoPrecioUseCase]  success:', productoCreado)

  return productoCreado
}